module.exports = __webpack_public_path__ + "img/BUCK-SLIDER-02.5d4f7a71.jpg";